interface IChartLogos {
  logos: (string | null)[];
  scale: number;
}
const shortScale = 999;
const longScale = 99999;

const ChartLogos = ({ logos, scale }: IChartLogos) => {
  const padding = scale < shortScale ? 'pl-6' : longScale < 99999 ? 'pl-10' : 'pl-16';
  return (
    <div className={`flex justify-around ${padding}`}>
      {logos.map((item, index) =>
        item ? (
          <img key={`chart-logo-${index}`} className='object-contain h-20 w-20' src={`${item}?width=100`} alt='Logo' />
        ) : (
          <div key={`chart-logo-placeholder-${index}`} className='object-contain h-20 w-20' />
        ),
      )}
    </div>
  );
};
export default ChartLogos;
